"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const admin_1 = __importDefault(require("evolution-frontend/lib/apps/admin"));
const application_config_1 = require("chaire-lib-frontend/lib/config/application.config");
const application_config_2 = __importDefault(require("evolution-frontend/lib/config/application.config"));
const template_1 = __importDefault(require("../survey/sections/visitedPlaces/template"));
const interviewerSupport_1 = __importDefault(require("evolution-interviewer/lib/client/services/interviewers/interviewerSupport"));
const sections_1 = __importDefault(require("../survey/sections"));
const widgetsConfigs_1 = require("../survey/widgetsConfigs");
const Monitoring_1 = __importDefault(require("./components/Monitoring"));
// TODO This is a workaround to get the links to the user, until some more complete solution is implemented (see https://github.com/chairemobilite/transition/issues/1516)
const pages = application_config_2.default.pages;
pages.push({ path: '/interviews', permissions: { Interviews: ['read', 'update'] }, title: 'customLabel:Interviewers' });
(0, application_config_1.setApplicationConfiguration)((0, interviewerSupport_1.default)({
    sections: sections_1.default,
    widgets: widgetsConfigs_1.widgets,
    allowedUrlFields: ['source', 'accessCode'],
    templateMapping: Object.assign(Object.assign({}, application_config_2.default.templateMapping), { visitedPlaces: template_1.default }),
    // FIXME See why we need the cast, it does not compile otherwise
    getAdminMonitoringComponents: () => Monitoring_1.default,
    pages
}));
(0, admin_1.default)();
